import React, { useEffect, useState } from "react";
import { api, formatEUR } from "@/lib/api";
import { Trophy, Phone, FileSignature } from "lucide-react";

const MEDALS = { 1: "🥇", 2: "🥈", 3: "🥉" };

export default function CoachLeaderboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/coach/leaderboard").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const all = data.classement || [];
  const hasActivity = all.some((r) => r.relances > 0 || r.signatures > 0);
  const top = all.slice(0, 6);
  const meRow = data.me ? all.find((r) => r.vendeur_id === data.me) : null;
  const meOutside = meRow && meRow.rang > 6;

  const Row = ({ r, highlight }) => (
    <tr
      data-testid={`leaderboard-row-${r.vendeur_id}`}
      className={`border-t border-slate-100 ${highlight ? "bg-[#B8873A]/10" : ""}`}
    >
      <td className="px-4 py-2.5 w-10 text-center font-bold text-slate-500">
        {MEDALS[r.rang] || r.rang}
      </td>
      <td className="px-4 py-2.5 font-medium text-[#111111] truncate">
        {r.name}{highlight && <span className="ml-2 text-[10px] uppercase tracking-wider text-[#B8873A] font-bold">Toi</span>}
      </td>
      <td className="px-4 py-2.5 text-right text-slate-700">{r.relances}</td>
      <td className="px-4 py-2.5 text-right font-semibold text-emerald-700">{r.signatures}</td>
      <td className="px-4 py-2.5 text-right text-[#111111] font-semibold hidden sm:table-cell">{formatEUR(r.ca)}</td>
    </tr>
  );

  return (
    <div className="mb-8 bg-white border border-slate-200 rounded-sm overflow-hidden" data-testid="coach-leaderboard">
      <div className="flex items-center gap-2 px-5 py-3 border-b border-slate-100">
        <Trophy className="w-4 h-4 text-[#B8873A]" />
        <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-700">Classement de la semaine</h3>
        <span className="ml-auto text-xs text-slate-400">depuis le {data.semaine_du}</span>
      </div>

      {!hasActivity ? (
        <div className="px-5 py-8 text-center text-sm text-slate-500" data-testid="leaderboard-empty">
          La semaine commence 🏁 — sois le premier à marquer des points&nbsp;! Chaque relance et chaque signature te font grimper.
        </div>
      ) : (
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="px-4 py-2 w-10 text-center font-semibold uppercase text-[10px] tracking-wider">#</th>
              <th className="px-4 py-2 text-left font-semibold uppercase text-[10px] tracking-wider">Vendeur</th>
              <th className="px-4 py-2 text-right font-semibold uppercase text-[10px] tracking-wider"><Phone className="w-3 h-3 inline -mt-0.5" /> Relances</th>
              <th className="px-4 py-2 text-right font-semibold uppercase text-[10px] tracking-wider"><FileSignature className="w-3 h-3 inline -mt-0.5" /> Signés</th>
              <th className="px-4 py-2 text-right font-semibold uppercase text-[10px] tracking-wider hidden sm:table-cell">CA</th>
            </tr>
          </thead>
          <tbody>
            {top.map((r) => <Row key={r.vendeur_id} r={r} highlight={r.vendeur_id === data.me} />)}
            {meOutside && (
              <>
                <tr><td colSpan={5} className="px-4 py-1 text-center text-slate-300 text-xs">· · ·</td></tr>
                <Row r={meRow} highlight />
              </>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
